import React, { useEffect, useState } from "react"
import {
	Create,
	FormTab,
	TabbedForm,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import RecipientTab from "./RecipientTab"
import DetailTab from "./DetailTab"
import EmailTab from "./EmailTab"
import { prepareData } from "./prepareData"
import FormTabWithBadge from "utils/FormTabWithBadge"
import { ITemplateData } from "./interfaces/i-template-data"
import { fetchTemplatesData } from "utils/mailjet"
import { validateEvent } from "./validate-event"

const EmailAddressCreate = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.events.notifications.create",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/events")
		refresh()
	}

	const [templatesData, setTemplatesData] = useState<ITemplateData[]>()

	useEffect(
		() => {
			const init = async () => {
				setTemplatesData(await fetchTemplatesData())
			}

			init()
		},
		[]
	)

	return (
		<Create
			mutationOptions={{ onSuccess }}
			transform={prepareData}
			title="resources.events.create"
		>
			<TabbedForm
				validate={(values: any) => validateEvent(values)}
			>

				<FormTab label="resources.events.details.name">
					<DetailTab />
				</FormTab>

				<FormTabWithBadge label="resources.events.recipients.name" badge="eventContacts">
					<RecipientTab enableResponse={false} />
				</FormTabWithBadge>

				<FormTab label="resources.events.email.name">
					<EmailTab templatesData={templatesData} type="email" />
				</FormTab>

				<FormTab label="resources.events.follow_up.name">
					<EmailTab templatesData={templatesData} type="follow_up" />
				</FormTab>

			</TabbedForm>
		</Create>
	)
}

export default EmailAddressCreate
